import { Box } from '@mui/material';
import React from 'react';
export const Spacing48 = () => {
  return <Box sx={{ height: '48px', visibility: 'hidden' }}></Box>;
};
